import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useMutation } from '@apollo/client'
import Dialog from '@/components/_custom/Dialog/Dialog.tsx'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader.tsx'
import DialogBody from '@/components/_custom/DialogBody/DialogBody.tsx'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon.tsx'
import { Close, Delete } from '@mui/icons-material'
import { useNotification } from '@/modules/context/NotificationContext.tsx'
import { SET_NOTIFICATION_SUGGEST_SETTINGS } from '@/modules/API/daycare/daycareSuggestHandler.ts'
import styles from './notificationSuggest.module.scss'

interface DeleteContactEmailDialogProps {
    open: boolean
    handleClose: () => void
    daycareId: number
    currentEmails: string[]
    notification: boolean
    emailToDelete: string
    onSuccess: (newEmails: string[]) => void
}

const DeleteContactEmailDialog: FunctionComponent<DeleteContactEmailDialogProps> = ({
    open,
    handleClose,
    daycareId,
    currentEmails,
    notification,
    emailToDelete,
    onSuccess
}: DeleteContactEmailDialogProps) => {
    const { t } = useTranslation()
    const { showNotificationSuccess, showNotificationError } = useNotification()

    const filteredEmails: string[] = currentEmails.filter((e) => e !== emailToDelete)

    const [deleteContactEmail] = useMutation(SET_NOTIFICATION_SUGGEST_SETTINGS, {
        variables: { daycareId, contactEmails: filteredEmails, notification },
        onCompleted: () => {
            onSuccess(filteredEmails)
            handleClose()
            showNotificationSuccess(t('contactEmailDeleted'))
        },
        onError: () => {
            showNotificationError(t('contactEmailDeletedError'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('deleteContactEmail')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.TextContainer}>
                    <p className={styles.Text}>
                        {t('deleteContactEmailMessage')} <span>{emailToDelete}</span> ?
                    </p>
                    <p className={styles.Text}>{t('noRollBack')}</p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={() => deleteContactEmail()}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default DeleteContactEmailDialog
